import React, { useContext, useEffect, PropsWithChildren } from 'react';
import { FormProvider, UseFormMethods, useWatch } from 'react-hook-form';
import { SubmitFormContext, SubmitFormContextValue } from '../../../context';
import { SubmitAdapter } from '../../../types';

import s from './InlineExclusiveForm.scss';

interface Props {
  formName: string;
  formContext: UseFormMethods<any>;
  submitAdapter?: SubmitAdapter;
}

const InlineExclusiveForm: React.FC<PropsWithChildren<Props>> = ({
  children,
  formName,
  formContext,
  submitAdapter,
}) => {
  const {
    initResponse,
    registerNestedForm,
    unregisterNestedForm,
    registerSubmitAdapter,
    unregisterSubmitAdapter,
  } = useContext(SubmitFormContext) || ({} as SubmitFormContextValue);
  const deviation = initResponse?.deviation;
  const sellExclusiveToggle = useWatch({
    name: 'sellExclusiveToggle',
  });

  // Register this nested form when it's active
  useEffect(() => {
    if (sellExclusiveToggle && deviation) {
      registerNestedForm(formName, formContext);
      if (submitAdapter) {
        registerSubmitAdapter(formName, submitAdapter);
      }
      return () => {
        unregisterNestedForm(formName);
        if (submitAdapter) {
          unregisterSubmitAdapter(formName);
        }
      };
    }
  }, [
    sellExclusiveToggle,
    deviation,
    registerNestedForm,
    unregisterNestedForm,
    registerSubmitAdapter,
    unregisterSubmitAdapter,
    submitAdapter,
    formName,
    formContext,
  ]);

  return (
    <div className={s['root']}>
      <FormProvider {...formContext}>{children}</FormProvider>
    </div>
  );
};
InlineExclusiveForm.displayName = 'InlineExclusiveForm';

export default InlineExclusiveForm;
